module.exports = __webpack_public_path__ + "img/fish-frozen.060d989c.png";